'use strict';

import {isFalse} from '@uw-it-sis/lib-react/lib/Utils';
import {RegEx} from "@uw-it-sis/lib-react/lib/ValidationUtils";
import {ProtocolLabels} from "./Constants";

/**
 * Accepts a string of 10 digits prefixed with the US country code (+1) and formats then into a formatted phone number
 * @param number - string of 10 digits prefixed with +1
 * @return {string|*}
 */
export function phoneFormat(number) {
    if (number) {
        const phoneData = number.match(RegEx.number);

        if (phoneData && phoneData.length === 4) {
            return `(${phoneData[1]}) ${phoneData[2]}-${phoneData[3]}`;
        } else {
            return number;
        }
    } else {
        return number;
    }

}

/**
 * Accepts a formatted phone number and strips away any special characters, spaces, and international code (+1)
 * @param string - a formatted phone number
 * @return {string|null} - 10 digits that make up a US phone number
 */
export function phoneDigits(string) {
    if (string && string !== "" && string !== null) {
        let digits = string.replace(/\D/g,'');
        if ( digits.length === 11 && string.startsWith('+') && digits.startsWith('1') ) {
            return digits.substring(1);
        } else if ( digits.length <= 10 ) {
            return digits;
        } else {
            return null;
        }
    } else {
        return null;
    }
}

/**
 * Return a set of flags set to true if any activity within the given list has at least one of those flags set.
 *
 * @param subscriptions list of activities
 * @return {{enrollRestriction: boolean, addCode: boolean}}
 */
export function getSectionLegendFlags(subscriptions) {
    let legends = {
        enrollRestriction: false,
        addCode: false
    };

    for (let subscription of subscriptions) {
        // if the activity has a state key, check that it is active
        if (!subscription.section.stateKey || subscription.section.stateKey.toLowerCase() === 'active') {

            let activityAddCode = subscription.section.addCodeRequired || subscription.section.independentStudy;

            // check if already true, if a single activity has addCodeRequired or independentStudy, legend show is true
            if (isFalse(legends.addCode)) {
                legends.addCode = activityAddCode;
            }

            // check if already true, the enrollment restriction isn't from an activity add code
            // and the activity has the enroll restriction field set to true, legend show is true
            if (isFalse(legends.enrollRestriction) && isFalse(activityAddCode)) {
                legends.enrollRestriction = subscription.section.enrollRestriction;
            }

        }

        if ( Object.keys(legends).map(key => legends[key]).every(value => value) ) { break; }
    }

    return legends;
}

/**
 * Takes an array of strings and joins them with commas and an "and" between the last two.
 * @param array - array of strings
 * @param omitAnd - if true, omits the "and" between the last two items
 * @returns {*|string}
 */
export const joinStringWithAnd = (array, omitAnd = false) => {
    if (typeof array === "object" && array) {
        if (array.length === 1) return array[0];
        if (omitAnd) {
            return array.join(', ');
        } else {
            const firsts = array.slice(0, array.length - 1);
            const last = array[array.length - 1];
            return firsts.join(', ') + (firsts.length > 1 ? ',':'') + ' and ' + last;
        }
    } else {
        return array;
    }
}

export const getEndpointLabel = (protocol) => {
    return ProtocolLabels[protocol] ? ProtocolLabels[protocol].text : protocol;
}
